import NemesisChart from 'nemesischart';
import 'nemesischart/style.css';

export function setupNemesisChart(app) {
  app.use(NemesisChart);
}
